export enum ColumnId {
  SLOT_NO = "slot_no",
  SLOT_TIME = "slot_time",
  PATIENT_NAME = "patient_name",
  MOBILE_NO = "mobile_no",
  CLINIC_NAME = "clinic_name",
  PATIENT_TYPE = "patient_type",
  STATUS = "status",
  BOOKING_DATE = "booking_date",
}

export enum ScheduleStatus {
  COMPLETED = "Completed",
  CANCELLED = "Cancelled",
  UPCOMING = "Upcoming",
  PENDING = "Pending",
}

export enum ConsultationType {
  VIDEO_CONSULTATION = "videoconsultation",
  IN_PERSON = "inperson",
  InClinic = "inClinic",
  VideoConsultation = "videoConsultation",
}

export enum PatientType {
  NEW = "new",
  OLD = "old",
}

export enum FilterType {
  CLINIC_NAME = "Clinic Name",
  CONSULTATION_TYPE = "Consultation type",
  STATUS = "Status",
  PATIENT_TYPE = "Patient Type",
}

export interface AppointmentData {
  clinic_id?: string;
  [ColumnId.SLOT_NO]: string;
  [ColumnId.SLOT_TIME]: string;
  [ColumnId.PATIENT_NAME]: string;
  [ColumnId.MOBILE_NO]: string;
  [ColumnId.CLINIC_NAME]: string;
  [ColumnId.PATIENT_TYPE]: PatientType;
  [ColumnId.STATUS]: ScheduleStatus;
  [ColumnId.BOOKING_DATE]: string;
  consultation_type: ConsultationType;
}

export enum AppointmentReportsActionType {
  SET_PAGE = "SET_PAGE",
  SET_ROWS_PER_PAGE = "SET_ROWS_PER_PAGE",
  SET_EXPORTING = "SET_EXPORTING",
  TOGGLE_DATE_RANGE = "TOGGLE_DATE_RANGE",
  SET_FILTER = "SET_FILTER",
}

export enum FilterField {
  CLINIC = "clinic",
  STATUS = "status",
  PATIENT_TYPE = "patientType",
  CONSULTATION_TYPE = "consultationType",
  CLINIC_NAME = "CLINIC_NAME",
}

export type Filters = {
  [FilterField.CLINIC]: string;
  [FilterField.STATUS]: ScheduleStatus | "";
  [FilterField.PATIENT_TYPE]: PatientType | "";
  [FilterField.CONSULTATION_TYPE]: ConsultationType | "";
};

export type AppointmentReportsState = {
  page: number;
  rowsPerPage: number;
  isExporting: boolean;
  showDateRange: boolean;
  filters: Filters;
};

export enum ConsultationType {
  IN_CLINIC = "inClinic",
  VIDEO = "videoConsultation",
}

export enum ConsultationTypeFilter {
  IN_CLINIC = "1",
  VIDEO = "2",
}

export type AppointmentReportsAction =
  | { type: AppointmentReportsActionType.SET_PAGE; payload: number }
  | { type: AppointmentReportsActionType.SET_ROWS_PER_PAGE; payload: number }
  | { type: AppointmentReportsActionType.SET_EXPORTING; payload: boolean }
  | { type: AppointmentReportsActionType.TOGGLE_DATE_RANGE }
  | {
      type: AppointmentReportsActionType.SET_FILTER;
      payload: { field: FilterField; value: string };
    };
